// Maps text sizes to pixel values
// If sizes differ by screen size, create a map for the screen size and its associated pixel value
var EyebrowSize = new Map();
EyebrowSize.set(1, 12);
EyebrowSize.set(2, 14);
export var getEyebrowSize = function (_a) {
    var size = _a.size;
    return EyebrowSize.get(size);
};
export default {};
